<template>
	<div class="imgUpload">
		<img :src="comSrc" class="img-show">
		<input type="file" accept="image/*" capture="camera" v-if="!changeAble && isAllowUploadImg=='false'" @change="photoCompress($event)">
		<input type="file" accept="image/*" v-if="!changeAble && isAllowUploadImg=='true'" @change="photoCompress($event)">
	</div>
</template>

<script>
	export default {
		props: ["tag", "value", "changeAble", 'src'],
		name: "imgUpload",
		data() {
			return {
				base64: '',
				isAllowUploadImg:'false',
				imgSrc: this.src
			};
		},
		mounted() {
			this.getIsAllowUploadImgFun()
		},
		watch: {
			src(newValue, oldValue) {
				// console.log('src');
				this.imgSrc = newValue;
			}
		},
		computed: {
			comSrc() {
				return this.imgSrc || this.src
			}
		},
		methods: {
			photoCompress(e) {
			//   console.log('photoCompress => e ', e)
				var that = this;
				var file = e.target.files[0]; // js 获取文件对象
				if (!file || !window.FileReader) return;
				this.$dialog.loading.open("图片上传中");
				this.$common.photoCompress(file, function (base64) {
					// console.log(base64)
					that.base64 = base64.split(',')
					that.upLoadImg(base64);
				});
			},
			getIsAllowUploadImgFun(base64) {
				var that = this;
				that.$common.infoSubmit("/app/business/businessParam/map", {}, function (res) {
					that.isAllowUploadImg=res.isAllowUploadImg;
				}, function () {

				});
			},
			upLoadImg(base64) {
				var that = this;
				var sendData = new Object();
				sendData.type = that.tag;
				sendData.imgBase64 = base64.split(",")[1];
				that.$common.infoSubmit("/app/uploadFile/upload/img", sendData, function (res) {
					that.$dialog.loading.close();
					that.$emit("input", res);
					that.$emit("uplodCallBack", that.tag)
					that.imgSrc = base64
					that.$toast.success("上传成功！");
				}, function () {
					that.$dialog.loading.close();
				});
			}
		}
	};
</script>

<style scoped>
	.imgUpload {
		position: relative;
		height: 100%;
	}

	.imgUpload img {
		display: block;
		height: 100%;
		margin: 0 auto;
	}

	.imgUpload input {
		display: block;
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		opacity: 0;

	}
</style>



// WEBPACK FOOTER //
// src/components/inputComponent/imgUpload.vue